var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{class:`${_vm.classes}`,style:(`
      border-radius:${_vm.radius};
      color:${_vm.colorsec};
      box-shadow:${_vm.shadow};
      background-color: ${_vm.bgcolor};
      border: ${_vm.btnOutline};`),attrs:{"size":"lg","name":"check-button","button-variant":"yellow","switch":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }